import { Bell } from "lucide-react";

interface NotificationBellProps {
  unreadCount: number;
  isOpen: boolean;
  onClick: () => void;
}

export default function NotificationBell({
  unreadCount,
  isOpen,
  onClick,
}: NotificationBellProps) {
  return (
    <button
      onClick={onClick}
      className={`relative flex h-10 w-10 items-center justify-center rounded-full border transition-all ${
        isOpen
          ? "border-blue-200 bg-blue-50 text-blue-600 shadow-sm"
          : "border-transparent bg-white text-gray-600 hover:border-gray-200 hover:bg-gray-50"
      }`}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ""}`}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
    >
      <Bell className="h-5 w-5" />
      {unreadCount > 0 && (
        <span className="absolute -right-1 -top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white shadow-sm ring-2 ring-white">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
}
